<template>
  <div>
    <!-- start: page -->
    <form
      class="ecommerce-form action-buttons-fixed"
      @submit.prevent="submitForm"
    >
      <div class="row">
        <div class="col">
          <section class="card card-modern card-big-info">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2-5 col-xl-1-5">
                  <i class="card-big-info-icon bx bx-slider"></i>
                  <h2 class="card-big-info-title">Detalji slidera</h2>
                  <p class="card-big-info-desc">Unesite detalje slidera</p>
                </div>

                <div class="col-lg-3-5 col-xl-4-5">
                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naziv
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naziv"
                        v-model="slider.internalTitle"
                      />
                    </div>
                  </div>
                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Naslov
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Naslov"
                        v-model="slider.title"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Velicina fonta naziva
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Velicina fonta naziva"
                        v-model="slider.titleFontSize"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja teksta naziva
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="slider.titleColour"
                            :swatches="swatches"
                            show-border
                            popover-x="left"
                            inline
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Glavni opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Glavni opis"
                        v-model="slider.mainDescription"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Velicina fonta glavnog opisa
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Velicina fonta glavnog opisa"
                        v-model="slider.mainDescriptionFontSize"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja teksta glavnog opisa
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="slider.mainDescriptionColour"
                            :swatches="swatches"
                            show-border
                            popover-x="left"
                            inline
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Sporedni opis
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <textarea
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Sporedni opis"
                        v-model="slider.secondaryDescription"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Velicina fonta sporednog opisa
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Velicina fonta sporednog opisa"
                        v-model="slider.secondaryDescriptionFontSize"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Boja teksta sporednog opisa
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="row">
                        <div class="col-10">
                          <v-swatches
                            v-model="slider.secondaryDescriptionColour"
                            :swatches="swatches"
                            show-border
                            popover-x="left"
                            inline
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Fusnota
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Fusnota"
                        v-model="slider.fusnote"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Link
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Link"
                        v-model="slider.contentUrl"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Link tekst
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Link tekst"
                        v-model="slider.linkText"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Vidljivo na webu?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          id="visible-on-web"
                          name="agreeterms"
                          type="checkbox"
                          v-model="slider.isVisibleOnWeb"
                        />
                        <label
                          class="control-label"
                          for="visible-on-web"
                        ></label>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Zadani sadržaj?
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <div class="checkbox-custom checkbox-default">
                        <input
                          id="default-content"
                          name="agreeterms"
                          type="checkbox"
                          v-model="slider.isDefaultContent"
                        />
                        <label
                          class="control-label"
                          for="default-content"
                        ></label>
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Poravnanje
                    </label>

                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="slider.alignment"
                        :multiple="false"
                        :options="alignments"
                        placeholder="Izaberite poravnanje"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Djelatnosti
                    </label>

                    <div class="col-lg-7 col-xl-6">
                      <treeselect
                        v-model="slider.jumbotronInterestsAreas"
                        :multiple="true"
                        :options="areas"
                        placeholder="Izaberite djelatnost"
                        v-if="areas"
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Dostupno na</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <select
                        class="form-control form-control-modern"
                        v-model="slider.jumbotronContentType"
                      >
                        <option
                          v-for="item in b2borb2cOptions"
                          :value="item.id"
                          :key="item.id"
                        >
                          {{ item.text }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div v-if="slider.jumbotronContentType == 1 || slider.jumbotronContentType == 3"
                  class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Redoslijed prikaza B2B
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="number"
                        class="form-control form-control-modern"
                        placeholder="Redoslijed prikaza"
                        v-model.number="slider.displayOrder"
                      />
                    </div>
                  </div>

                  <div v-if="slider.jumbotronContentType == 2 || slider.jumbotronContentType == 3"
                  class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Redoslijed prikaza B2C
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="number"
                        class="form-control form-control-modern"
                        placeholder="Redoslijed prikaza"
                        v-model.number="slider.displayOrderB2C"
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    v-if="slider.image"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika desktop slidera</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <div class="popup-gallery row">
                        <div class="img-fluid">
                          <img
                            class="img-thumbnail"
                            :src="`${baseUrl}${slider.image}`"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika desktop slidera</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="photo"
                        accept="image/*"
                        @change="handlePhotoUpload"
                      />
                      <div class="form-text">
                        Učitajte sliku rezolucije 1110px x 455px
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Sirina slike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Širina slike"
                        v-model="slider.imagePxWidth"
                        readonly
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Visina slike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Visina slike"
                        v-model="slider.imagePxHeight"
                        readonly
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                    v-if="slider.mobileImage"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika mobilnog slidera</label
                    >
                    <div class="col-lg-4 col-xl-3">
                      <div class="popup-gallery row">
                        <div class="img-fluid">
                          <img
                            class="img-thumbnail"
                            :src="`${baseUrl}${slider.mobileImage}`"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                      >Slika mobilnog slidera</label
                    >
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="file"
                        class="form-control form-control-modern"
                        ref="mobilePhoto"
                        accept="image/*"
                        @change="handleMobilePhotoUpload"
                      />
                      <div class="form-text">
                        Učitajte sliku rezolucije 920px x 1215px
                      </div>
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Sirina slike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Širina slike"
                        v-model="slider.mobileImagePxWidth"
                        readonly
                      />
                    </div>
                  </div>

                  <div
                    class="form-group row align-items-center mb-3"
                  >
                    <label
                      class="col-lg-5 col-xl-3 control-label text-lg-end mb-0"
                    >
                      Visina slike
                    </label>
                    <div class="col-lg-7 col-xl-6">
                      <input
                        type="text"
                        class="form-control form-control-modern"
                        placeholder="Visina slike"
                        v-model="slider.mobileImagePxHeight"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="form-group row align-items-center mb-3">
                    <div class="col-12">
                      <div
                        class="home-slide"
                        :style="{
                          backgroundImage: `url(${posterUrl || baseUrl + slider.image})`,
                        }"
                      >
                        <div
                          class="slide-content"
                          :class="`content-${slider.alignment}`"
                        >
                          <div class="text-wrapper">
                            <h2
                              :class="`text-${slider.alignment}`"
                              :style="{ color: slider.titleColour, fontSize: slider.titleFontSize + 'px' }"
                              v-if="slider.title"
                            >
                              {{ slider.title }}
                            </h2>
                            <div
                              class="skew-box-group"
                              v-if="slider.secondaryDescription || slider.mainDescription"
                            >
                              <span
                                class="skew-box"
                                v-if="slider.mainDescription"
                                :style="{
                                  color: slider.mainDescriptionColour,
                                  fontSize: slider.mainDescriptionFontSize + 'px'
                                }"
                              >
                                {{ slider.mainDescription }}
                              </span>
                              <span
                                class="skew-box"
                                :style="{
                                  color: slider.secondaryDescriptionColour,
                                  fontSize: slider.secondaryDescriptionFontSize + 'px'
                                }"
                                v-if="slider.secondaryDescription"
                              >
                                {{ slider.secondaryDescription }}
                              </span>
                            </div>
                          </div>
                          <a
                            v-if="slider.contentUrl"
                            :href="slider.contentUrl"
                            class="btn btn-light text-primary font-weight-bold bottom-absolute"
                            target="_blank"
                          >
                            {{ slider.linkText || slider.contentUrl }}
                          </a>
                        </div>
                        <p v-if="slider.fusnote">* {{ slider.fusnote }}</p>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
      <div class="action-buttons d-flex justify-content-between">
        <div>
          <button
            type="button"
            data-bs-toggle="modal"
            data-bs-target="#delete-modal"
            class="delete-button btn btn-danger btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-trash text-4 me-2"></i> {{ translations.delete }}
          </button>
        </div>
        <div class="d-flex gap-3">
          <router-link
            class="cancel-button btn btn-light btn-px-4 py-3 border font-weight-semibold text-color-dark text-3"
            exact
            :to="{ name: 'Sliders' }"
          >
            {{ translations.cancel }}
          </router-link>
          <button
            type="submit"
            class="ubmit-button btn btn-primary btn-px-4 py-3 d-flex align-items-center font-weight-semibold line-height-1"
          >
            <i class="bx bx-save text-4 me-2"></i> {{ translations.save }}
          </button>
        </div>
      </div>
      <modal id="delete-modal">
        <h5 slot="header">
          <strong>{{ translations.deleteSlider }}</strong>
        </h5>
        <div slot="body">
          <span v-html="modalText"> </span>
        </div>
        <div slot="footer">
          <div class="row">
            <div class="col-md-12 text-end">
              <button
                type="button"
                class="btn btn-primary px-4 mx-2"
                @click.prevent.stop="deleteSlider"
                data-bs-dismiss="modal"
              >
                {{ translations.yes }}
              </button>
              <button
                type="button"
                class="btn btn-default px-4"
                data-bs-dismiss="modal"
              >
                {{ translations.no }}
              </button>
            </div>
          </div>
        </div>
      </modal>
    </form>
    <!-- end: page -->
  </div>
</template>

<script>
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

import VSwatches from 'vue-swatches';
import 'vue-swatches/dist/vue-swatches.css';

import { translations } from "@/mixins";
import Modal from "@/components/shared/modal/Modal.vue";
import api from "@/services/api";
import config from "@/config";

export default {
  name: "EditSlider",
  mixins: [translations],
  components: {
    Treeselect,
    VSwatches,
    Modal,
  },
  data() {
    return {
      b2borb2cOptions: [
        {
          id: 1,
          text: 'B2B',
        },
        {
          id: 2,
          text: 'B2C',
        },
        {
          id: 3,
          text: 'Sve',
        },
      ],
      alignments: [
        {
          id: 'left-up',
          label: 'Lijevo gore',
        },
        {
          id: 'left-down',
          label: 'Lijevo dole',
        },
        {
          id: 'right-up',
          label: 'Desno gore',
        },
        {
          id: 'right-down',
          label: 'Desno dole',
        },
      ],
      posterUrl: '',
      mobilePosterUrl: '',
      swatches: ['#0088CC', '#fff', '#212529'],
    };
  },
  computed: {
    baseUrl() {
      return config.baseUrl;
    },
    slider() {
      return this.$store.getters.getJumbotron;
    },
    areas() {
      return this.$store.getters.getInterestsAreas.map((item) => {
        return {
          id: item.id,
          label: item.title,
        };
      });
    },
    modalText() {
      return this.translations.areYouSureSlider.replace(
        "{slider}",
        `<strong>${this.slider.title}</strong>`
      );
    },
  },
  methods: {
    submitForm() {
      const { slider } = this;

      if (!slider.mobileImagePxWidth || !slider.mobileImagePxHeight) {
        this.$toast.error(
          'Molimo učitajte sliku mobilnog slidera. Širina i visina mobilne slike su obavezni podaci i popunjavaju se automatski nakon učitavanja slike.'
        );
        return;
      }

      const formData = new FormData();
      formData.append("title", slider.title || '');
      formData.append("internalTitle", slider.internalTitle || '');
      formData.append("id", slider.id);
      formData.append("mainDescription", slider.mainDescription || '');
      formData.append("secondaryDescription", slider.secondaryDescription || '');
      formData.append("alignment", slider.alignment || '');
      formData.append("contentUrl", slider.contentUrl || '');
      formData.append("fusnote", slider.fusnote || '');
      formData.append("linkText", slider.linkText || '');
      formData.append("isVisibleOnWeb", slider.isVisibleOnWeb || false);
      formData.append("isDefaultContent", slider.isDefaultContent || false);
      formData.append("imagePxWidth", slider.imagePxWidth || '');
      formData.append("imagePxHeight", slider.imagePxHeight || '');
      formData.append("mobileImagePxWidth", slider.mobileImagePxWidth || '');
      formData.append("mobileImagePxHeight", slider.mobileImagePxHeight || '');
      formData.append('titleColour', slider.titleColour || '');
      formData.append('titleFontSize', slider.titleFontSize || '');
      formData.append('mainDescriptionColour', slider.mainDescriptionColour || '');
      formData.append('mainDescriptionFontSize', slider.mainDescriptionFontSize || '');
      formData.append('secondaryDescriptionColour', slider.secondaryDescriptionColour || '');
      formData.append('secondaryDescriptionFontSize',slider.secondaryDescriptionFontSize || '');
      formData.append('jumbotronContentType',slider.jumbotronContentType || 3);
      formData.append('displayOrder', slider.displayOrder || 1);
      formData.append('displayOrderB2C', slider.displayOrderB2C || 1);

      slider.jumbotronInterestsAreas.forEach((item) => {
        formData.append("interestsAreasIds", item);
      });

      if (this.$refs.photo.files[0]) {
        formData.append("image", this.$refs.photo.files[0]);
      }

      if (this.$refs.mobilePhoto.files[0]) {
        formData.append("mobileImage", this.$refs.mobilePhoto.files[0]);
      }

      api.updateJumbotron(formData).then((response) => {
        this.$toast.info(response.data.info);
        this.$router.push({ name: "Sliders" });
      });
    },
    deleteSlider() {
      api
        .deleteJumbotron(this.slider.id)
        .then((response) => {
          this.$toast.info(response.data.info);
          this.$router.push({ name: "Sliders" });
        })
        .catch((err) => {
          this.$toast.error(err?.response?.data?.info || 'Desila se greška');
          this.$router.push({ name: "Sliders" });
        });
    },
    handlePhotoUpload() {
      const file = this.$refs.photo.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = (e) => {
        this.slider.imagePxWidth = e.target.width;
        this.slider.imagePxHeight = e.target.height;
        this.posterUrl = img.src;
      };
    },
    handleMobilePhotoUpload() {
      const file = this.$refs.mobilePhoto.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);

      const img = new Image();
      img.src = URL.createObjectURL(file);

      img.onload = (e) => {
        this.slider.mobileImagePxWidth = e.target.width;
        this.slider.mobileImagePxHeight = e.target.height;
        this.mobilePosterUrl = img.src;
      };
    }
  },
  mounted() {
    this.$store.dispatch("getJumbotronById", this.$route.params.id);
    this.$store.dispatch("getInterestsAreas", {
      retrieveAll: true,
      sortBy: "title",
    });
  },
};
</script>
<style lang="scss" scoped>
@import './sliders.scss';
</style>